import type { StateCreator } from "zustand";
import type { HeraldChatSettingsSlice } from "./herald-chat-settings.slice";

type HeraldChatSettingsActions = Pick<
  HeraldChatSettingsSlice,
  | "toggleDeepAnalysis"
  | "setIsStreaming"
  | "setIsHeraldChatEmpty"
  | "setActiveConversationId"
>;

export const createHeraldChatSettingsActions: StateCreator<
  HeraldChatSettingsSlice,
  [["zustand/devtools", never]],
  [],
  HeraldChatSettingsActions
> = (set) => ({
  toggleDeepAnalysis: () =>
    set(
      (state) => ({ isDeepAnalysisEnabled: !state.isDeepAnalysisEnabled }),
      false,
      "heraldChatSettings/toggleDeepAnalysis",
    ),

  setIsStreaming: (streaming: boolean) =>
    set({ isStreaming: streaming }, false, "heraldChatSettings/setIsStreaming"),

  setIsHeraldChatEmpty: (empty: boolean) =>
    set(
      { isHeraldChatEmpty: empty },
      false,
      "heraldChatSettings/setIsHeraldChatEmpty",
    ),

  setActiveConversationId: (conversationId: string | null) =>
    set(
      { activeConversationId: conversationId },
      false,
      "heraldChatSettings/setActiveConversationId",
    ),
});
